import React, { useState } from "react";
import useApi from "../../api";
import { toast } from "react-toastify";
import { NXInvisible, NXVisible } from "../../icons";
import { InputField } from "../common";


const Password = () => {
  const api = useApi();
  const [formData, setFormData] = useState<any>({});
  const [showPassword, setShowPassword] = useState<any>({})
  const [errorData, setErrorData] = useState<any>({})

  const changePasswordVisiblity = (e: any, field:string) => {
    e.preventDefault()
    setShowPassword((prev:any)=>({...prev, [field]: !prev[field]}))
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e: any) => {
    e.preventDefault()
    if (formData.new_password === formData.confirm_password) {
      delete formData.confirm_password
      api
        .changePassword(formData)
        .then((response: any) => {
          toast.success("Password successfully changed.")
        }, (error)=>setErrorData(error.response.data))
        .catch((error) => toast.error("Password cannot be changed!!!"));
    } else {
      toast.error("Password not match")
    }
  };
  return (
    <div>
      <div className="flex flex-col gap-2">
        <strong className="text-lg">Password</strong>
        <span className="text-base-300 text-sm">
          Change or view your password.
        </span>
      </div>
      <form className="pt-4">
        <div className="flex flex-col w-full pt-4">
          <label htmlFor="old_password" className="text-sm text-base-300">
            Old Password
          </label>
          <div className="relative">
            <InputField
              id="old_password"
              type={showPassword.old_password ? 'text': 'password'}
              name="old_password"
              value={formData.old_password || ""}
              onChange={onChange}
              placeholder="Old Password"
              className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
              errorData={errorData}
            />
            <button onClick={(e)=>changePasswordVisiblity(e, 'old_password')} className="absolute top-[30px] right-5">
              {showPassword.old_password ? 
              <NXInvisible/>:
              <NXVisible/>}
            </button>
          </div>
        </div>
        <div className="flex flex-col w-full pt-6">
          <label htmlFor="new_password" className="text-sm text-base-300">
            New Password
          </label>
          <div className="relative">
            <InputField
              id="new_password"
              type={showPassword.new_password ? 'text': 'password'}
              name="new_password"
              value={formData.new_password || ""}
              onChange={onChange}
              placeholder="New Password"
              className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
              errorData={errorData}
            />
            <button onClick={(e)=>changePasswordVisiblity(e, 'new_password')} className="absolute top-[30px] right-5">
              {showPassword.new_password ? 
              <NXInvisible/>:
              <NXVisible/>}
            </button>
          </div>
        </div>
        <div className="flex flex-col w-full pt-6">
          <label htmlFor="confirm_password" className="text-sm text-base-300">
            Confirm Password
          </label>
          <div className="relative">
            <InputField
              id="confirm_password"
              type={showPassword.confirm_password ? 'text': 'password'}
              name="confirm_password"
              value={formData.confirm_password || ""}
              onChange={onChange}
              placeholder="Confirm Password"
              className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
              errorData={errorData}
            />
            <button onClick={(e)=>changePasswordVisiblity(e, 'confirm_password')} className="absolute top-[30px] right-5">
              {showPassword.confirm_password ? 
              <NXInvisible/>:
              <NXVisible/>}
            </button>
          </div>
        </div>
        <div className="flex justify-end pt-6">
          <button
            className="bg-primary-400 py-2 px-5 w-full md:w-[200px] text-white rounded-md hover:bg-primary-500 transition-all duration-150 ease-linear"
            onClick={handlePasswordChange}
          >
            Save changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default Password;
